export default {
      id: "icon_m_logo-usage",
      viewBox: "0 0 30 38",
      url: __webpack_public_path__ + "sprite.svg#icon_m_logo",
      toString: function () {
        return this.url;
      }
    }